import { useCallback, useEffect, useState } from "react";
import ListItem from "@material-ui/core/ListItem";
import {
  ListItemText,
  List,
  ListItemAvatar,
  ListItemSecondaryAction,
  IconButton,
  Tooltip,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useDropzone } from "react-dropzone";
import { Delete, InsertDriveFile } from "@mui/icons-material";
import UtilsFncs from "utils/UtilsFncs";

const useStyles = makeStyles({
  dropzone: {
    padding: "2rem 2rem 1rem",
    backgroundColor: "#fff",
    border: "1px dashed #dee2e6",
    borderRadius: ".375rem",
    textAlign: "center",
    color: "#8898aa",
    transition: "all .15s ease",
    cursor: "pointer",
    zIndex: 999,
  },
});

const FilesList = ({ files, removeFileFromList, disabled }) => {
  return (
    <List>
      <Grid container spacing={2}>
        {files?.map((file, index) => (
          <Grid item xs={12} md={6} lg={4} key={index}>
            <ListItem style={{ display: "flex", alignItems: "center" }}>
              <ListItemAvatar>
                <InsertDriveFile fontSize="small" />
              </ListItemAvatar>
              <ListItemText
                primary={file.name}
                primaryTypographyProps={{
                  variant: "caption",
                  color: "textPrimary",
                }}
                secondary={UtilsFncs.GetFileSize(file)}
                secondaryTypographyProps={{
                  variant: "caption",
                  color: "textPrimary",
                }}
              />
              <ListItemSecondaryAction>
                <Tooltip title="Remover arquivo">
                  <IconButton
                    onClick={() => removeFileFromList(index)}
                    disabled={disabled}
                  >
                    <Delete fontSize="small" />
                  </IconButton>
                </Tooltip>
              </ListItemSecondaryAction>
            </ListItem>
          </Grid>
        ))}
      </Grid>
    </List>
  );
};

export default function UploadFile({
  multiple = false,
  accept = null,
  message = "Selecione um arquivo ou arraste aqui",
  validator,
  onChangeFiles,
  disabled,
}) {
  const classes = useStyles();
  const [files, setFiles] = useState([]);

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    multiple,
    accept,
    validator,
  });

  useEffect(() => {
    setFiles(acceptedFiles);
  }, [acceptedFiles]);

  useEffect(() => {
    onChangeFiles(files);
  }, [files, onChangeFiles]);

  const removeFileFromList = useCallback(
    (position) => {
      const filesToRemove = files;

      filesToRemove.splice(position, 1);

      setFiles([...filesToRemove]);
    },
    [files]
  );

  return (
    <>
      <div {...getRootProps({ className: classes.dropzone })}>
        <input {...getInputProps()} disabled={disabled} />
        <p>{message}</p>
      </div>
      {files.length > 0 ? (
        <FilesList
          files={files}
          removeFileFromList={removeFileFromList}
          disabled={disabled}
        />
      ) : null}
    </>
  );
}
